import { useSetting } from "@/hooks/useSetting";
import { FC, useCallback, useEffect, useState } from "react";

import imgSetup from "@/assets/kofi-setup.png";
import { useSocketEvent } from "@/hooks/useSocketEvent";

export const Kofi: FC = () => {
    const [kofiToken, setKofiToken] = useSetting("kofi-verification-token");
    const [value, setValue] = useState<string | undefined>(kofiToken);
    const [testSuccess, setTestSuccess] = useState(false);

    useSocketEvent("donation", (e) => {
        if (e.provider === "kofi") {
            setTestSuccess(true);
        }
    });

    useEffect(() => {
        setValue(kofiToken);
    }, [kofiToken]);

    const handleSave = useCallback(() => {
        setKofiToken(value);
    }, [value, setKofiToken]);

    return (
        <div className="max-h-screen min-w-xl flex flex-col items-center justify-center">
            <h1 className="text-4xl text-center" aria-label="Under Construction">
                <img src="https://storage.ko-fi.com/cdn/logomarkLogo.png" alt="Ko-fi Logo" className="inline-block h-8 mr-2" /> Ko-fi Setup
            </h1>
            <p className="text-center mt-4">
                To set up the Ko-fi integration, you need to create a webhook in your <a href="https://ko-fi.com/manage/webhooks" target="_blank" rel="noopener noreferrer" className="underline">Ko-fi account settings</a>.<br/>
                <br/>
                1) Enter the following URL in the "Webhook URL" field and save the changes:
            </p>
            <input
                type="text"
                className="mt-4 p-2 border rounded w-full max-w-md bg-gray-600 text-blue-200"
                value={`${import.meta.env.VITE_OVERLAY_URL}/kofi`}
                readOnly
            />

            <p className="text-center mt-4">
                2) Copy the Ko-fi verification token from your Ko-fi account settings and paste it below:<br/>
            </p>
            <div className="flex flex-row items-center justify-center mt-4 w-full max-w-md">
                <input
                    type="text"
                    className="p-2 border rounded w-full max-w-md"
                    placeholder="Enter your Ko-fi verification token"
                    value={value ?? ""}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button
                    className="ml-2 px-4 py-2 bg-violet-500 text-white rounded hover:bg-violet-600 transition"
                    onClick={handleSave}
                >
                    Save
                </button>
            </div>
            <p className="text-center mt-4">
                You can find this token in your <a href="https://ko-fi.com/manage/webhooks" target="_blank" rel="noopener noreferrer" className="underline">Ko-fi account settings under the "API" section</a>.<br/>
                Be sure to expand the "Advanced" section to find the token.
            </p>
            <img src={imgSetup} alt="Screenshot showing where to find the Ko-fi verification token in the Ko-fi account settings" className="w-1/2 mt-12 rounded shadow-lg" />
            <p className="text-center mt-4">
                After entering the token, your overlay should be able to receive Ko-fi events such as new donations and subscriptions.<br/>
                <br/>
                You can test the integration by clicking the "Send Single Donation Test"-Button on the Ko-fi API Page If everything is set up correctly, the Donation-Train should trigger and Donation-Goals should update accordingly.
            </p>
            {testSuccess && (
                <p className="p-4 text-green-500">
                    Test successful! Your overlay is receiving Ko-fi events.
                </p>
            )}
        </div>
    );
}